import React from 'react'
//import './GroupCustomerDataList.css';
import ReactPaginate from "react-paginate";
import { useEffect, useState } from "react";
import Axios from "../../../services/AxiosInstance";
//import { Navigate, useNavigate } from 'react-router-dom';
import Notification from "../../Notification";
// import { Autocomplete } from '@material-ui/lab';
// import { TextField } from '@material-ui/core';
// import Box from '@material-ui/core';





// import "./BusinessList1.css";
function GroupCustomerDataList() {

    const [businessNameData, setbusinessNameData] = useState([]);
    //const [groupCustomerData,setGroupCustomerData]=useState([]);
    const [businessGroupData, setbusinessGroupData] = useState([]);
    const [searchData, setsearchData] = useState('');
    const [items, setItems] = useState([]);
    // const [posts, setPosts] = useState([]);
    const [totalPages, setTotalPage] = useState(0);
    const [pageCount, setpageCount] = useState(0);
    const [loading, setLoading] = useState(false)
    const [delGroupCustomerDataList, setdelGroupCustomerDataList] = useState('');
    const [isChecked, setisChecked] = useState(false);
    const [viewMoreData, setviewMoreData] = useState([]);
    const [notify, setNotify] = useState({ isOpen: false, messsage: '', type: '' })

    // const [filterData, setFilterData] = useState([]);
    // const [query, setQuery] = useState('');
    //const navigate = useNavigate();

    // const [BusinessName, setBusinessName] = useState()
    const [sortToggle, setSortToggle] = useState(true);
    const [perPage, setPerpage] = useState(process.env.REACT_APP_PER_PAGE)
    //const [callFunc, setCallFunc] = useState([]);


    // let perPage = 2;
    // let currentPage="";
    //let groupData_list = "";

    useEffect(() => {
        const getGroupCustomerDataList = async () => {
            const res = await Axios.get(`api/business/list-group-customer-data?pageNo=1&perPage=${perPage}`)
            // console.log(res)
            setItems(res.data.data.data);
            // console.log(res.data.data.data);
            // setFilterData(res.data.data.data)
            setTotalPage(res.data.data.totalPage)
            setpageCount(Math.ceil(res.data.data.totalPage));
            setLoading(false)
            localStorage.removeItem('sort_key');
            localStorage.removeItem('sort_order');
        };
        getGroupCustomerDataList();
        SearchBusinessName();
    }, [perPage]);

    if (loading && items.length === 0) {
        return <h2>Loading...</h2>
    }
    const SearchBusinessName = async (e) => {
        Axios
            .get(`api/business/get-business-name-dropdown`, {
            }).then((response) => {
                console.log(response);

                console.log(response.data.data[0])
                setbusinessNameData(response.data.data[0]);
            }).catch(() => {
                console.log("Invalid Credentials");
            });
        // console.log(stateId);
        // await setBusinessName(e.target.options[e.target.selectedIndex].text);
        // console.log(BusinessName);
    }
    const businessList = businessNameData.map((list) => {
        return (
            <option key={list.business_id} value={list.business_id}>{list.business_name}</option>
        )
    })

    const fetchGroupCustomerDataList = async (currentPage) => {

        const sort_key = localStorage.getItem('sort_key');
        const sort_order = localStorage.getItem('sort_order');
        let sortUrl = "";
        if (sort_key && sort_order) {
            sortUrl = `&sortkey=${sort_key}&order=${sort_order}`;
        }
        const res = await Axios.get(`api/business/list-group-customer-data?pageNo=${currentPage}&perPage=${perPage}${sortUrl}`)
        await setItems(res.data.data.data);
        return items;
    };

    const handlePageClick = async (items) => {
        let currentPage = items.selected + 1;
        const searchBy = document.getElementById("search_by_id").value;
        if (searchData !== "" && searchBy !== "") {

            await searchHandle(currentPage);

        } else {

            await fetchGroupCustomerDataList(currentPage);
        }

    };
    const handleChange = (e) => {
        // alert("Hi");
        const { name, checked } = e.target;

        if (name === "allSelect") {
            let tempItems = items.map((GroupCustomerDataList) => {
                return { ...GroupCustomerDataList, isChecked: checked };
            });
            //   console.log(tempItems)
            //   return false;
            setisChecked(tempItems)
            setItems(tempItems);
        }
        else {
            let tempItems = items.map((GroupCustomerDataList) =>
                GroupCustomerDataList.group_user_id === name ? { ...GroupCustomerDataList, isChecked: checked } : GroupCustomerDataList
            );
            // console.log(tempItems)
            //   return false;
            setisChecked(tempItems)
            setItems(tempItems);

        }
    }
    const alldelete = async (e) => {

        const status = e.target.value
        let GroupCustomerDataLength = isChecked.length;
        let GroupCustomerDataIdArray = [];
        if (GroupCustomerDataLength > 0) {
            for (let i = 0; i < GroupCustomerDataLength; i++) {
                console.log(isChecked[i]);
                if (isChecked[i].isChecked === true) {
                    let businessID = isChecked[i].group_user_id;
                    GroupCustomerDataIdArray.push({ group_user_id: businessID });
                }
            }
        }

        if (isChecked) {
            const res = await Axios.post(`api/business/update-group-customer-data-status`, { group_user_id: GroupCustomerDataIdArray, action_status: status });
            setdelGroupCustomerDataList(res.data)
            console.log(delGroupCustomerDataList);

            // setTimeout(()=>{
            //     alert("Business has been deleted successfully!")
            //     // navigate(`/businessList`);
            // }, 1000);
            setNotify({
                isOpen: true,
                messsage: `Business has been ${status} successfully!`,
                type: 'success',

            })
            window.location.reload(false);

        }
        else {
            alert("please Select at least one check box !");
            //console.log("hii");
        }
    }


    const searchHandle = async (currentPage) => {
        const searchBy = document.getElementById("search_by_id").value;
        //console.log("hii", searchBy)
        if (searchData !== "" && searchBy !== "") {
            const res = await Axios.get(`api/business/list-group-customer-data?pageNo=${currentPage}&searchData=${searchData}&search_by=${searchBy}`)

            if (res.data.data.data.length > 0) {
                setItems(res.data.data.data)
                setTotalPage(res.data.data.totalPage)
                setpageCount(Math.ceil(res.data.data.totalPage));
            } else {
                setItems([]);
            }

        } else {
            setNotify({
                isOpen: true,
                messsage: `Search By and Search Value Should Not Be Blank!`,
                type: 'success',

            })
        }

    }

    // const search = async (searchData) => {
    //     if (searchData.length > 1) {
    //         const res = await Axios.get(`api/business/get-business-dropdown?searchData=${searchData}`)

    //         if (res.data.data.data.length > 0) {

    //             setItems(res.data.data.data)
    //         }
    //     }
    // }



    const handleSortdesc = async (sortkey, order) => {
        if (sortkey) {
            setSortToggle(true);
            localStorage.setItem("sort_key", sortkey)
            localStorage.setItem("sort_order", order)
            const res = await Axios.get(`api/business/list-group-customer-data?pageNo=1&perPage=${perPage}&sortkey=${sortkey}&order=${order}`)
            if (res.data.data.data.length > 0) {
                setItems(res.data.data.data);
                // setSortToggle(true);
            }
        }
    }

    const handleSortasc = async (sortkey, order) => {
        if (sortkey) {
            console.log(sortkey)
            setSortToggle(false);
            localStorage.setItem("sort_key", sortkey)
            localStorage.setItem("sort_order", order)
            const res = await Axios.get(`api/business/list-group-customer-data?pageNo=1&perPage=${perPage}&sortkey=${sortkey}&order=${order}`)
            if (res.data.data.data.length > 0) {
                setItems(res.data.data.data);



            }
        }
    }


    const getBusinessGroupList = async (business_id) => {
        Axios
            .get(`api/business/get-group-name-dropdown?business_id=${business_id}`, {
            }).then((response) => {
                console.log(response);

                //console.log(response.data.data[0]);
                setbusinessGroupData(response.data.data[0]);
                console.log(businessGroupData);
            }).catch(() => {
                console.log("Invalid Credentials");
            });

    }
    const fetchGroupCustomerList = async (group_id) => {
        alert("hello")

        // const res = await Axios.get(`api/business/list-group-customer-data?group_id=${group_id}`)
        const res = await Axios.get(`api/business/list-group-customer-data?pageNo=1&perPage=${perPage}&group_id=${group_id}`)
        console.log(res.data.data.data);

        if (res.data.data.data.length > 0) {
            setItems(res.data.data.data);
            // setTotalPage(res.data.data.data.totalPage)
            // setpageCount(Math.ceil(res.data.data.totalPage));

        } else {
            setItems([]);
            setTotalPage(res.data.data.totalPage)
            setpageCount(Math.ceil(res.data.data.totalPage));

        }
    }

    const groupList = businessGroupData.map((list) => {
        return (
            <option key={list.group_id} value={list.group_id}>{list.group_name}</option>
        )
    })
    const viewMore = async (group_user_id) => {
        alert('hii');
        const status = group_user_id;
        console.log('hii', status);
        const res = await Axios.get(`api/business/list-group-customer-data?group_user_id=${group_user_id}`)
        setviewMoreData(res.data.data.data[0])
        console.log(res.data.data.data[0]);
    }


    return (
        <>

            <div className="content-page">
                <div className="content">

                    {/* <h1>{totalPages}</h1> */}
                    {/* <!-- Start Content--> */}
                    <div className="container-fluid">

                        {/* <!-- start page title --> */}
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box">
                                    {/* <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item"><a href="javascript: void(0);">Techzoni</a></li>
                                        <li className="breadcrumb-item"><a href="javascript: void(0);">Tables</a></li>
                                        <li className="breadcrumb-item active">Datatable</li>
                                    </ol>
                                </div> */}
                                    <h4 className="page-title">Group Customer Data List</h4>
                                </div>
                            </div>
                        </div>
                        {/* <!-- end page title -->  */}

                        <div className="row">
                            <div className="col-md-6">
                                <div className="business_head">
                                    <button className="btn btn-danger" type="button" value="Deleted" onClick={(e) => alldelete(e)} >DELETE</button>
                                    <button className="btn btn-primary" type="button" value="Active" onClick={(e) => alldelete(e)}  >Active All</button>
                                    <button className="btn btn-primary" type="button" value="Inactive" onClick={(e) => alldelete(e)}>Inactive All</button>
                                </div>
                            </div>
                            <div className='col-md-6'>
                            <div class="slect-busines-data">
                                {
                                            notify.isOpen ?
                                                <Notification
                                                    notify={notify}
                                                    setNotify={setNotify} />
                                                : ""
                                        }
                                        <span><b>Select Business: </b></span>
                                        <select
                                            onChange={(e) => { getBusinessGroupList(e.target.value) }}
                                            id="business_name"
                                            type="text"
                                            className="form-control"
                                            style={{
                                                height: "35px", width: "26%", display: "inline-block", position: "relative",
                                                borderRadius: '10px ',
                                                border: "1px solid black",
                                                marginRight: "20px",
                                            }}
                                        >
                                            <option>Business Name</option>
                                            {businessList}
                                        </select>



                                        <span><b>Select Group: </b></span>
                                        <select
                                            onChange={(e) => { fetchGroupCustomerList(e.target.value) }}
                                            id="Group_name"
                                            type="text"
                                            className="form-control"

                                            style={{
                                                height: "35px", width: "26%", display: "inline-block", position: "relative",
                                                borderRadius: '10px ',
                                                border: "1px solid black"
                                            }}
                                        >
                                            <option>Group Name </option>

                                            {groupList}
                                        </select>
                                </div>
                            
                            </div>
                            <div className='col-md-12'>
                                <div className='business_head business_head_rigt'>

                                <span><b>Search By:-</b></span>
                                        <select name="search_by" id="search_by_id">
                                            <option value="">Select</option>
                                            <option value="business_id">Business ID</option>
                                            <option value="business_name">Business Name</option>
                                            <option value="mobile_no">Mobile No</option>
                                            <option value="group_id">Group_id</option>
                                            <option value="group_name">Group Name</option>
                                            <option value="first_name">frist_Name</option>

                                        </select>

                                        <input type="" className='search-GroupCustomerData-list' placeholder='Search...'
                                            onChange={(e) => setsearchData(e.target.value)}
                                        />
                                        <button type="Search" className="find-list" onClick={searchHandle}>Search</button>
                                </div>

                            </div>

                            <div className="col-12">
                                <div className="card-box table-responsive">
                                    

                                    <table id="datatable" className="table table-bordered business_tb  dt-responsive nowrap" style={{ padding: "30px", margin: "20px" }}>
                                        <thead>
                                            <tr>
                                                <td><input
                                                    type="checkbox"
                                                    // business_id="allSelect" 
                                                    name="allSelect"
                                                    checked={!items.some((GroupCustomerDataList) => GroupCustomerDataList?.isChecked !== true)}
                                                    onChange={handleChange} /> <label className="form-check-label ms-2">All Select</label></td>

                                                <td>S.No</td>
                                                <td >Business_id
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("business_id", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("business_id", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </td>

                                                <td >Business Name
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("business_name", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("business_name", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </td>

                                                <td > Mobile No.
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("mobile_no", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("mobile_no", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </td>



                                                {/* <td >Group ID
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("group_id", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("group_id", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </td> */}
                                                <td >Group Name
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("group_name", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("group_name", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </td>

                                                <td >Frist Name
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("first_name", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("first_name", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </td>

                                                <td >Last Name
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("last_name", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("last_name", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </td>
                                                {/* <td >Tag Name
                                                </td> */}

                                                {/* <td >Group user ID
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("group_user_id", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("group_user_id", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </td> */}

                                                {/* <td>CP_User_ID
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("cp_user_id", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px", marginRight: "30px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("cp_user_id", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px", marginRight: "30px" }}></i>
                                                    )}
                                                </td> */}
                                                {/* 
                                                <td >Excel ID
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("excel_id", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("excel_id", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </td> */}
                                                {/* <td >Added By
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("added_by", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("added_by", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </td> */}

                                                {/* <td >Added Date
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("added_date", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("added_date", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </td> */}
                                                {/* <td >Date Time Stam
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("date_time_stamp", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("date_time_stamp", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </td> */}

                                                <td >Status
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("status", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("status", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </td>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {items.map((GroupCustomerDataList, index) =>
                                                <tr key={index}>
                                                    <td><input
                                                        type="checkbox"
                                                        name={[GroupCustomerDataList.group_user_id]}
                                                        // business_id={businessList.business_id}
                                                        checked={GroupCustomerDataList?.isChecked || false}
                                                        onChange={handleChange}
                                                    />  </td>
                                                    <td>{index + 1}</td>
                                                    <td>{GroupCustomerDataList.business_id}</td>
                                                    <td>{GroupCustomerDataList.business_name}</td>
                                                    <td>{GroupCustomerDataList.mobile_no}</td>
                                                    {/* <td>{GroupCustomerDataList.group_id}</td> */}
                                                    <td>{GroupCustomerDataList.group_name}</td>
                                                    <td>{GroupCustomerDataList.first_name}</td>
                                                    <td>{GroupCustomerDataList.last_name}</td>
                                                    {/* <td>{GroupCustomerDataList.tag_name}</td> */}
                                                    {/* <td>{GroupCustomerDataList.group_user_id}</td> */}
                                                    {/* <td>{GroupCustomerDataList.cp_user_id}</td> */}
                                                    {/* <td>{GroupCustomerDataList.excel_id}</td> */}
                                                    {/* <td>{GroupCustomerDataList.added_by}</td> */}
                                                    {/* <td>{GroupCustomerDataList.added_date}</td> */}
                                                    {/* <td>{GroupCustomerDataList.date_time_stamp}</td> */}
                                                    <td>{GroupCustomerDataList.status}</td>

                                                    <td><button
                                                        type="button" className="btn btn-primary"
                                                        data-toggle="modal"
                                                        data-target="#exampleModalCenter"
                                                        value={GroupCustomerDataList.group_user_id}
                                                        onClick={(e) => viewMore(e.target.value)}
                                                    >
                                                        View More</button></td>

                                                </tr>)}
                                        </tbody>
                                    </table>


                                    <div className="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                        <div className="modal-dialog modal-dialog-centered" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title" id="exampleModalLongTitle">GROUP CUSTOMER DATA LIST</h5>
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    <div className="container">
                                                        <div className="row">
                                                            <div className="col-md-6 col-lg-6 col-xl-6">
                                                                <p><strong>S.No:- </strong></p>
                                                                <p><strong>Business_id:-{viewMoreData.business_id}</strong></p>
                                                                <p><strong>business_name:-{viewMoreData.business_name}</strong></p>
                                                                <p><strong>mobile_no:-{viewMoreData.mobile_no}</strong></p>
                                                                <p><strong>group_id:-{viewMoreData.group_id}</strong></p>
                                                                <p><strong>group_name:-{viewMoreData.group_name}</strong></p>
                                                                <p><strong>first_name:-{viewMoreData.first_name}</strong></p>
                                                                <p><strong>last_name:-{viewMoreData.last_name}</strong></p>
                                                                <p><strong>tag_name:-{viewMoreData.tag_name}</strong></p>
                                                                <p><strong>group_user_id:-{viewMoreData.group_user_id}</strong></p>
                                                            </div>

                                                            <div className="col-md-6 col-lg-6 col-xl-6">

                                                                <p><strong>cp_user_id:-{viewMoreData.cp_user_id}</strong></p>
                                                                <p><strong>excel_id:-{viewMoreData.excel_id}</strong></p>
                                                                <p><strong>added_by:-{viewMoreData.added_by}</strong></p>
                                                                <p><strong>added_date:-{viewMoreData.added_date}</strong></p>
                                                                <p><strong>date_time_stamp:-{viewMoreData.date_time_stamp}</strong></p>
                                                                <p><strong>status:-{viewMoreData.status}</strong></p>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="modal-footer">
                                                    <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                                                    <button type="button" className="btn btn-primary">Save changes</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                    <ReactPaginate
                                        previousLabel={"previous"}
                                        nextLabel={"next"}
                                        breakLabel={"..."}
                                        pageCount={pageCount}
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={3}
                                        onPageChange={handlePageClick}
                                        containerClassName={"pagination justify-content-center"}
                                        pageClassName={"page-item"}
                                        pageLinkClassName={"page-link"}
                                        previousClassName={"page-item"}
                                        previousLinkClassName={"page-link"}
                                        nextClassName={"page-item"}
                                        nextLinkClassName={"page-link"}
                                        breakClassName={"page-item"}
                                        breakLinkClassName={"page-link"}
                                        activeClassName={"active"}
                                    />
                                    <div>

                                        <span><b>Rows per page:-</b></span>
                                        <select name="Rows per page" className="item-page" onChange={(e) => setPerpage(e.target.value)}>
                                            <option value="">Select Item Per Page</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="30">30</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                            <option value="200">200</option>
                                        </select>
                                    </div>

                                </div>
                            </div>
                        </div>
                        {/* <!-- end row --> */}
                    </div>
                    {/* <!-- end container-fluid --> */}

                </div>
            </div>

            {/* <!-- end content --> */}

        </>
    );
}

export default GroupCustomerDataList;